import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DepartmentOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { departmentOptionSelectors } from '../state/department-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: DepartmentSelectComponent,
        },
    ],
    selector: 'ndt-department-select',
    templateUrl: './department-select.component.html',
    standalone: false
})
export class DepartmentSelectComponent extends LcsSingleSelectBase<DepartmentOption> implements OnInit {
   @Input() departmentsToExclude: DepartmentOption[] = [];

   departments: Observable<DepartmentOption[] | null>;

   inactiveDepartmentsList: DepartmentOption[] = [];

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      const departments$ = this.store.pipe(select(departmentOptionSelectors.selectFilteredItems), this.itemsLoaded());
      this.departments = departments$.pipe(
         map((departments) => {
            return departments.filter((department) => {
               return (
                  !this.departmentsToExclude.find((dep) => dep.departmentId === department.departmentId) &&
                  department.isActive
               );
            });
         })
      );
      const allDepartments = departments$;
      allDepartments.subscribe((departments) => {
         this.inactiveDepartmentsList = departments.filter((department) => !department.isActive);
      });
   }

   displayWith(item: DepartmentOption | null): string | null {
      if (!item || !item.name) return null;
      return item.name;
   }

   trackBy(item: DepartmentOption | null) {
      return item ? item.departmentId : null;
   }
}
